/**
 * FacetMenuTag Component
 */

import * as React from 'react';

import { IQueryStringContext, QueryStringContext } from '../../../../contexts/queryString';
import Tag from '../../../molecules/Tag';

interface IOwnProps {
  cardinality?: number;
  hasSubtags: boolean;
  term: GQL.ITaxonomyTerm;
  onClose(): Promise<{}>;
  onClickSubTags(termId: string): void;
}

type PropsFromQueryStringContext = Pick<IQueryStringContext, 'addSearchFilter'>;

type FacetMenuTagProps = IOwnProps & PropsFromQueryStringContext;

class FacetMenuTag extends React.PureComponent<FacetMenuTagProps> {

  onClickSubTags = () => {
    this.props.onClickSubTags(this.props.term.id);
  }

  onClickAdd = async () => {
    await this.props.onClose();
    this.props.addSearchFilter({name: this.props.term.name!});
  }

  onClickExclude = async () => {
    await this.props.onClose();
    this.props.addSearchFilter({name: this.props.term.name!}, true);
  }

  render() {
    const {
      cardinality,
      hasSubtags,
      term,
    } = this.props;

    return (
      <Tag
        id={term.id}
        label={term.name!}
        variant="button"
        size="small"
        colorScheme="transparent"
        wrappedComponent="li"
        cardinality={cardinality}
        onClick={this.onClickAdd}
        onClickExclude={this.onClickExclude}
        onClickSubTags={this.onClickSubTags}
        hasSubtags={hasSubtags}
      />
    );
  }
}

const FacetMenuTagWithQueryStringContext: React.SFC<IOwnProps> = (props) => (
  <QueryStringContext.Consumer>
    {({ addSearchFilter }) => <FacetMenuTag addSearchFilter={addSearchFilter} {...props} />}
  </QueryStringContext.Consumer>
);

export default FacetMenuTagWithQueryStringContext;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/search/FacetMenu/FacetMenuTag.tsx